import { useConfigContext } from "@voxmedia/duet-context/context/config-context";

const KNOWN_PROPS = ["id", "componentContext"];

type DataAttrValue = string | number | boolean;

type DataAttributes = { [key: string]: DataAttrValue };

/*
 * This function is useful for debugging purposes. Given any component props
 * object, the caller can spread its return value as data attributes in the
 * component HTML.
 */
export const useDataAttributes = (componentProps: {
  [key: string]: any;
}): DataAttributes => {
  const {
    appConfig: { deployEnv },
  } = useConfigContext();

  if (deployEnv === "production") {
    return {};
  }

  return KNOWN_PROPS.reduce<DataAttributes>((dataAttrs, propName) => {
    if (
      Object.prototype.hasOwnProperty.call(componentProps, propName) &&
      ["string", "number", "boolean"].includes(typeof componentProps[propName])
    ) {
      const componentPropValue = componentProps[propName] as DataAttrValue;
      const kebabPropName = propName
        .replace(/([a-z])([A-Z])/g, "$1-$2")
        .toLowerCase();
      dataAttrs[`data-${kebabPropName}`] = componentPropValue;
    }

    return dataAttrs;
  }, {});
};
